module.exports = __webpack_public_path__ + "img/DSC_3767.24eec1fb.jpg";